<template>
  <div class="reset-landing">
    <!-- Whoever lands here already has the app (reset is only requestable
         from it): they opened the email on desktop, or on a stale build. -->
    <div class="reset-landing__card">
      <h1 class="reset-landing__title">
        Open this link on your phone
      </h1>
      <p class="reset-landing__subtitle">
        You asked for this reset from the Bzioup app, so the
        new-password screen lives there too.
      </p>

      <div class="reset-landing__steps">
        <p class="reset-landing__step">
          <strong>Reading this on a computer?</strong>
          Open the same email on the phone where Bzioup is installed.
          The link goes straight to the new-password screen.
        </p>
        <p class="reset-landing__step">
          <strong>Already on your phone?</strong>
          Your app is too old to catch the link. Update Bzioup below,
          then ask for a new reset link from the login screen: this one
          expires after 5 minutes.
        </p>
      </div>

      <AppDownloadCTA variant="card"
:show-heading="false" />

      <div class="reset-landing__divider"></div>

      <router-link to="/"
class="reset-landing__home-link">
        ← Back to the Bzioup home
      </router-link>
    </div>
  </div>
</template>

<script>
import AppDownloadCTA from '@/components/Sections/AppDownloadCTA.vue'

export default {
  name: 'ResetPasswordLandingView',
  components: { AppDownloadCTA },
}
</script>

<style lang="scss" scoped>
.reset-landing {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--bzioup-bg-color-Z, #f7f6f3);
}

.reset-landing__card {
  max-width: 480px;
  width: 100%;
  background: var(--bzioup-bg-color-A, #fff);
  border-radius: 16px;
  padding: 32px 28px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(8, 20, 72, 0.08);
}

.reset-landing__title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.3;
}

.reset-landing__subtitle {
  margin: 8px 0 24px;
  font-size: 15px;
  color: var(--bzioup-text-color-soft, #777);
}

.reset-landing__steps {
  text-align: left;
  margin: 0 0 28px;
}

.reset-landing__step {
  margin: 0 0 14px;
  font-size: 14px;
  line-height: 1.55;
  color: var(--bzioup-text-color, #333);

  &:last-child { margin-bottom: 0; }

  strong { display: block; }
}

.reset-landing__divider {
  height: 1px;
  background: rgba(0, 0, 0, 0.08);
  margin: 24px 0 20px;
}

.reset-landing__home-link {
  display: inline-block;
  font-size: 13px;
  color: var(--bzioup-text-color-soft, #888);
  text-decoration: none;

  &:hover { color: var(--bzioup-color-pink); }
}
</style>
